import { TFunction } from "i18next";
import * as yup from "yup";
import { SchemaOf } from "yup";

interface corporateSubmitValidationProps {
  userId?: string;
  merchantNumber?: string;
  password?: string;
  captchaValue?: string;
}

interface individualSubmitValidationProps {
  phoneNumber?: string;
  password?: string;
  captchaValue?: string;
}

export const corporateSubmitValidationSchema = (
  t: TFunction
): SchemaOf<corporateSubmitValidationProps> =>
  yup.object().shape({
    userId: yup
      .string()
      .required(t("user_code_corporate_validation").toString()),
    merchantNumber: yup
      .string()
      .required(t("mbb_number_corporate_validation").toString()),
    password: yup
      .string()
      .matches(/^\d+$/, t("password_only _digits_validation").toString())
      .required(t("password_validation").toString())
      .min(6, t("password_min_valid").toString()),
    captchaValue: yup.string().min(4, t("captcha_min_valid").toString()),
  });
export const individualSubmitValidationSchema = (
  t: TFunction
): SchemaOf<individualSubmitValidationProps> =>
  yup.object().shape({
    phoneNumber: yup
      .string()
      .required(t("phone_number_required_validation").toString())
      .min(10, t("phone_number_min_valid").toString()),
    password: yup
      .string()
      .matches(/^\d+$/, t("password_only _digits_validation").toString())
      .required(t("password_validation").toString())
      .min(6, t("password_min_valid").toString()),
    captchaValue: yup.string().min(4, t("captcha_min_valid").toString()),
  });
